<template>
  <main class="fixed_adjustment">
    <section class="section_box">
      <div class="inner">
        <h2 class="tit_style05">退会手続き</h2>
        <h3 class="tit_style07">ご利用ありがとうございました。</h3>
        <div class="inner03">
          <div class="btn_size08 btn_style11 mg0">
            <a href="/">オンラインショップTOP</a>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "VWithdrawal3"
};
</script>

<style></style>
